import AiStarIcon from "@redotech/redo-icons/ai-star.svg";
import BoldIcon from "@redotech/redo-icons/bold-01.svg";
import ItalicIcon from "@redotech/redo-icons/italic-01_filled.svg";
import StrikethroughIcon from "@redotech/redo-icons/strikethrough-01_filled.svg";
import UnderlineIcon from "@redotech/redo-icons/underline-01_filled.svg";
import ZapIcon from "@redotech/redo-icons/zap.svg";
import { useMetaKey } from "@redotech/redo-web/command-palette/hooks/use-meta-key";
import { EmojiToolbarButton } from "@redotech/redo-web/components/plate-ui/emoji-toolbar-button";
import { LinkToolbarButton } from "@redotech/redo-web/components/plate-ui/link-toolbar-button";
import { MarkToolbarButton } from "@redotech/redo-web/components/plate-ui/mark-toolbar-button";
import {
  FileToolbarButton,
  ImageToolbarButton,
} from "@redotech/redo-web/components/plate-ui/media-toolbar-buttons";
import {
  ToolbarButton,
  ToolbarGroup,
} from "@redotech/redo-web/components/plate-ui/toolbar";
import { ToolbarWithOverflow } from "@redotech/redo-web/components/plate-ui/toolbar-overflow";
import { cn } from "@redotech/redo-web/tailwind-utils";
import { KEYS } from "platejs";
import { memo } from "react";

function OrangeAiStarIcon() {
  return <AiStarIcon style={{ color: "var(--redo-colors-orange-dark-500)" }} />;
}

export interface ChatToolbarProps {
  className?: string;
  onFileSelect?: (files: File[]) => void;
  onImageSelect?: (file: File) => void;
}

export const ChatToolbar = memo(function ChatToolbar({
  className,
  onFileSelect,
  onImageSelect,
}: ChatToolbarProps) {
  const metaKey = useMetaKey();

  return (
    <ToolbarWithOverflow className={cn("border-border px-1 py-1", className)}>
      <ToolbarGroup>
        <ToolbarButton Icon={OrangeAiStarIcon} tooltip="AI assist" />
        <ToolbarButton Icon={ZapIcon} tooltip="Macros" />
      </ToolbarGroup>

      <ToolbarGroup>
        <MarkToolbarButton
          Icon={BoldIcon}
          nodeType={KEYS.bold}
          tooltip={`Bold (${metaKey}+B)`}
        />
        <MarkToolbarButton
          Icon={ItalicIcon}
          nodeType={KEYS.italic}
          tooltip={`Italic (${metaKey}+I)`}
        />
        <MarkToolbarButton
          Icon={UnderlineIcon}
          nodeType={KEYS.underline}
          tooltip={`Underline (${metaKey}+U)`}
        />
        <MarkToolbarButton
          Icon={StrikethroughIcon}
          nodeType={KEYS.strikethrough}
          tooltip="Strikethrough"
        />
      </ToolbarGroup>

      <LinkToolbarButton />
      <EmojiToolbarButton />
      <ImageToolbarButton onImageSelect={onImageSelect} />
      <FileToolbarButton onFileSelect={onFileSelect} />
    </ToolbarWithOverflow>
  );
});
